import {isLoggedIn} from "modules/selectors";
import React from "react";
import {useSelector} from "react-redux";
import {Outlet, useLocation} from "react-router";
import {Navigate, type RouteProps} from "react-router-dom";

export const PrivateRoute: React.FC<RouteProps> = () => {
	const location = useLocation();

	if (useSelector(isLoggedIn)) {
		return <Outlet />;
	}

	return <Navigate to="/" state={{from: location}} replace />;
};
